<template>
  <div class="w-4/5 text-gray-400 mx-auto lg:mt-20">
      <div class="grid md:grid-cols-4 grid-cols-2 gap-4 self-center">

        <div>
          <!-- <img src="../assets/logo.png" alt="" class="w-3/6 mt-4"> -->

          <div class="flex mt-6 hidden">

            <img src="../assets/Instagram.png" alt="" class="mr-8 hidden">

            <a href="https://twitter.com/AskAvaOfficial" target="_blank">
              <img src="../assets/twitter.png" alt="twitter" class="mr-8">
            </a>

            <img src="../assets/facebook.png" alt="" class="mr-8 hidden">

          </div>

        </div>

        <div class="italic text-gray-400 text-xs font-light hidden">
          <h3 class="text-gray-600 mb-3 text-lg font-base">Ask AVA</h3>
          <h4 class="mb-1">How does it work?</h4>
          <h4 class="mb-1">Team</h4>
          <h4 class="mb-1">Enterprise</h4>
          <h4 class="mb-1">Blog</h4>
        </div>

        <div class="italic text-gray-400 text-xs font-light hidden">
          <h3 class="text-gray-600 mb-3 text-lg font-base">Platform</h3>
          <h4 class="mb-1">Web</h4>
          <h4 class="mb-1">iOS</h4>
          <h4 class="mb-1">Android</h4>
        </div>

        <div class="italic text-gray-400 text-xs font-light hidden">
          <h3 class="text-gray-600 mb-3 text-lg font-base">About</h3>
          <h4 class="mb-1">Community</h4>
          <h4 class="mb-1">Company</h4>
          <h4 class="mb-1">Career</h4>
          <h4 class="mb-1">API</h4>
        </div>

      </div>
      <h4 class="text-center py-5">©2023 - HUGO  |  All Rights Reserved</h4>
      <!-- This example requires Tailwind CSS v2.0+ -->

  </div>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style>
</style>